var HomepageGtm = function () {
  var init = function () {
    $(document).ready(function () {
      $('.homepage a').each(function(index, element) {
        $(element).on('click', sendGtm)
      })
    })
  }

  var sendGtm = function(event) {
    var linkText = event.text || $(event.target).text().trim()
    var linkLocation = event.location || $(event.target).data('section')

    if (!linkText) {
      linkText = $(event.target).find('img').attr('alt')
    }

    if (window.dataLayer && linkText && linkLocation) {
      window.dataLayer.push({
        'event': 'homepage_link_click',
        'link_text': linkText,
        'link_location': linkLocation
      });
    }
  }

  return {
    init: init,
    sendGtm: sendGtm
  }
}();

UL.register(HomepageGtm)
